import api from "../../../../../api";

export const requestCreatePartOfferReview = (payload) => {
    return api.post(`/partofferreview`, payload);
};

export const requestSendSupportMessage = (payload) => {
    return api.post(`/user/support`, payload);
};